import * as React from 'react';
import { useContext } from 'react';
import { OrderCardContext } from '../OrderCard';
import CommonItem from '../CommonItem/CommonItem';
import WaitPaymentText from '../OrderStatus/OrderStatusText/WaitPaymentText/WaitPaymentText';
import { OrderStatus } from '@websky/graphql';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import { CancelOrderConfirm } from '../../../__fsd__/features/cancel-order';

const PaymentStatus: React.FC = props => {
	const { order, type } = useContext(OrderCardContext);
	const theme = useTheme('OrderCard').PaymentStatus;

	return (
		order.status === OrderStatus.Booked && (
			<CommonItem
				className={cn(theme.root, {
					[theme.account]: type === 'account'
				})}
				iconClassName={theme.icon}
				payloadClassName={theme.payload}
				icon={'Info/Time'}
				text={<WaitPaymentText />}
				buttons={<CancelOrderConfirm orderId={order.id} />}
			/>
		)
	);
};

export default PaymentStatus;
